<template>
    <div class="form-group">
        <div class="input-group">
            <div class="loading-input-container">
                <div class="loading-message" v-if="checkingPostcode">Checking postcode</div>
                <input
                    class="form-control postcode-search"
                    :class="{'is-loading': checkingPostcode, 'is-invalid': error}"
                    :disabled="checkingPostcode"
                    placeholder="Enter your postcode"
                    type="text"
                    v-model="postcode"
                    v-on:keyup="postcodeWatcher"
                />
            </div>
            <div class="input-group-append">
                <button class="btn btn-primary continue-btn" type="button" @click="checkPostcode()">Get started</button>
            </div>
        </div>
        <small v-if="postcodeEmpty" class="form-text text-white"><i class="fa fa-exclamation-triangle mr-1"></i> Please enter a postcode</small>
        
        <!-- Error modal -->
        <b-modal
                body-class="p-0"
                cancel-disabled
                hide-footer
                id="error-modal"
                title="">
            <div class="modal-body modal-body-lg pt-0">
                <div>
                    <animated-error class="mx-auto mb-4"></animated-error>
                </div>
                <h4 class="text-center mb-4">{{ error }}</h4>
                <p class="text-center">
                    <button @click="$bvModal.hide('error-modal')" class="btn btn-outline-dark">{{ $t('bp.closeButton') }}</button>
                </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "LandingPagePostcodeSearch",
    data() {
        return {
            checkingPostcode: false,
            error: null,
            postcode: null,
            postcodeEmpty: false,
        }
    },

    computed: {
        ...mapGetters([
            'bookingPostcode',
            'carrierDetails',
            'onlyOfferSamsung'
        ])
    },

    methods: {
        ...mapActions([
            'clearBookingPostcode',
            'loadTypes',
            'selectMake',
            'setBookingPostcode'
        ]),

        checkPostcode() {
            this.postcodeEmpty = false;
            this.error = null;

            if (!this.postcode) return this.postcodeEmpty = true;

            let postcode = this.postcode.replace(/\s/g, '');

            if (!postcode) return this.postcodeEmpty = true;

            const requestParams = {model_version_id: null, problems: null};

            this.checkingPostcode = true;
            this.setBookingPostcode({postcode, requestParams})
                .then(() => {
                    this.checkingPostcode = false;

                    if (this.onlyOfferSamsung) {
                        this.selectMake({
                            id: 2
                        }).then(() => {
                            this.loadTypes();
                            this.$router.push({name: 'deviceType'});
                        })
                        return
                    }

                    this.$router.push({name: 'deviceMake'});
                })
                .catch(error => {
                    this.checkingPostcode = false;
                    this.error = error.response.data.messages[0];
                    if (this.carrierDetails.additionalLandingPage) {
                        this.$router.push({name: 'repairOptionsExternal'});
                        this.displayToast({text: this.error, type: 'error'});
                    } else {
                        this.$bvModal.show("error-modal")
                    }
                });
        },

        postcodeWatcher(event) {
            if(event.key === "Enter") {
                this.checkPostcode();
            }
        },
    }
}
</script>

<style scoped>

</style>